// extracted by css-extract-rspack-plugin
export default {"borderRight":"UHOeq","sailboat":"B7Xxl","previewImage":"kQEWU"};